import { render, staticRenderFns } from "./KsCheckbox.vue?vue&type=template&id=1209c165"
import script from "./KsCheckbox.vue?vue&type=script&lang=js"
export * from "./KsCheckbox.vue?vue&type=script&lang=js"
import style0 from "./KsCheckbox.vue?vue&type=style&index=0&id=1209c165&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports